
import { SESSION_REFRESH, SESSION_INIT, SETTINGS_SAVE } from "../../shared/timeclock/actions";
import { Config } from "../../shared/timeclock/models";

const defaultConfig = {
    autoCompleteChars: 3,
    iso639LanguageCode: "en",
    selfRegistrationEnabled: true,
    serverUrl: "",
    serverVersion: null,
    signatureRefreshSec: 10 * 60 * 1000,
    terminalGuid: "",
    terminalName: null
};

export function config(state: Config, action: {type: string, refreshResponse: {serverVersion: string}, config: Record<string, unknown>}): Config {

    if (state === undefined) {
        return defaultConfig;
    }

    if (action.type === SESSION_INIT || action.type === SESSION_REFRESH) {
        const info = {
            newVersion: action.refreshResponse.serverVersion,
            oldVersion: state.serverVersion,
            reload: action.refreshResponse.serverVersion !== state.serverVersion,
            type: action.type
        };

        console.log(info);

        if (info.reload) {
            location.reload();
        }
    }

    switch (action.type) {
        case SETTINGS_SAVE:
            return { ...state, ...action.config };
        default:
            return { ...defaultConfig, ...state };
    }
}
